import * as yup from 'yup';

const validationSchema = yup.object({
  mdToolboxUsername: yup.string().required('Username is required'),
  mdToolboxPracticeId: yup.string().required('Practice ID is required'),
  mdToolboxPassword: yup.string().required('Password is required'),
  mdToolboxTokenPassword: yup.string().required('Token Password is required'),
});

export { validationSchema };
